import * as React from "react";

import { format } from "date-fns";
import { Trans, WithTranslation, withTranslation } from "react-i18next";

import { IOrder as INexusOrder } from "~/graphql/queries/order/orderByName";
import NexusRMAOrderItem from "./NexusRMAOrderItem";

export interface INexusRMAOrderItem {
  orderItemId: string;
  barcode?: string | undefined | null;
  quantity: number;
}

interface IProps {
  nexusOrder: INexusOrder | undefined;
  rmaOrderItems: INexusRMAOrderItem[];
  onChange: (rmaOrderItems: INexusRMAOrderItem[]) => void;
}

class NexusRMAProductSelector extends React.Component<
  IProps & WithTranslation
> {
  public render() {
    const { nexusOrder, rmaOrderItems } = this.props;

    if (nexusOrder === undefined) {
      return null;
    }

    const { name: orderNumber } = nexusOrder;
    const orderDate = format(new Date(nexusOrder.insertedAt), "dd-MM-yyyy");

    return (
      <div>
        <Trans i18nKey="rmaForm:order.productSelector.header">
          Bestelling {{ orderNumber }} geplaatst op {{ orderDate }}:
        </Trans>

        {nexusOrder.orderLineItems.edges.map(({ node: orderLineItem }) => {
          const rmaOrderItem = rmaOrderItems.find(
            roi => roi.orderItemId === orderLineItem.id
          );

          if (!rmaOrderItem) {
            return null;
          }

          return (
            <NexusRMAOrderItem
              key={orderLineItem.id}
              orderLineItem={orderLineItem}
              rmaOrderItem={rmaOrderItem}
              onQuantityChange={this.handleQuantityChange(orderLineItem.id)}
            />
          );
        })}
      </div>
    );
  }

  public handleQuantityChange = (orderItemId: string) => (quantity: number) => {
    this.props.onChange(
      this.props.rmaOrderItems.map(rmaOrderLineItem =>
        rmaOrderLineItem.orderItemId === orderItemId
          ? {
              ...rmaOrderLineItem,
              quantity
            }
          : rmaOrderLineItem
      )
    );
  };
}

export default withTranslation("rmaForm")(NexusRMAProductSelector);



// WEBPACK FOOTER //
// ./src/components/RMAForm/NexusRMAProductSelector.tsx